module.exports = __webpack_public_path__ + "img/medal.5b0ae215.png";